import { atom } from "recoil";
import PackageModel from "../Models/Package.model";
export const PackageAtom = atom({
  key: "PackageAtom", // unique ID (with respect to other atoms/selectors)
  default: new PackageModel(), // default value (aka initial value)
});
